import React from 'react';

const ICONS = {
  gift: (
    <g>
      <rect x='3' y='8' width='18' height='4' rx='1' />
      <path d='M12 8v13' />
      <path d='M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7' />
      <path d='M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5' />
    </g>
  ),
  'badge-percent': (
    <g>
      <path d='M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z' />
      <line x1='15' x2='9' y1='9' y2='15' />
      <circle cx='9.5' cy='9.5' r='0.5' fill='currentColor' />
      <circle cx='14.5' cy='14.5' r='0.5' fill='currentColor' />
    </g>
  ),
  'arrow-up': (
    <g>
      <path d='M12 19V5' />
      <path d='m5 12 7-7 7 7' />
    </g>
  ),
  'arrow-up-right': (
    <g>
      <path d='M7 7h10v10' />
      <path d='M7 17 17 7' />
    </g>
  ),
  eye: (
    <g>
      <path d='M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z' />
      <circle cx='12' cy='12' r='3' />
    </g>
  ),
  copy: (
    <g>
      <rect width='14' height='14' x='8' y='8' rx='2' ry='2' />
      <path d='M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2' />
    </g>
  ),
  check: (
    <g>
      <path d='M20 6 9 17l-5-5' />
    </g>
  ),
  lock: (
    <g>
      <rect width='18' height='11' x='3' y='11' rx='2' ry='2' />
      <path d='M7 11V7a5 5 0 0 1 10 0v4' />
    </g>
  ),
  sparkles: (
    <g>
      <path d='M12 3 13.9 8.6 19.5 10.5 13.9 12.4 12 18 10.1 12.4 4.5 10.5 10.1 8.6 12 3Z' />
      <path d='M19 3v4' />
      <path d='M17 5h4' />
      <path d='M5 17v4' />
      <path d='M3 19h4' />
    </g>
  ),
  ticket: (
    <g>
      <path d='M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z' />
      <path d='M13 5v2' />
      <path d='M13 17v2' />
      <path d='M13 11v2' />
    </g>
  ),
};

export default function Icon({ name, size = 16 }) {
  const node = ICONS[name];
  if (!node) {
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn(`Icon "${name}" not found`);
    }
    return null;
  }
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      style={{
        flexShrink: 0,
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    >
      {node}
    </svg>
  );
}
